import { registerBlockType } from '@wordpress/blocks';
import { useBlockProps, InnerBlocks, InspectorControls } from '@wordpress/block-editor';
import { PanelBody, SelectControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

registerBlockType('puroclean/card', {
    edit({ attributes, setAttributes }) {
        const { backgroundColor } = attributes;
        
        const blockProps = useBlockProps({
            className: 'card-block'
        });

        // Get the background class based on the selected color
        const getBackgroundClass = (color) => {
            return color === 'blue' ? 'bg-secondary-900' : 'bg-primary';
        };

        // Template for inner blocks - suggests what blocks to add
        const ALLOWED_BLOCKS = [
            'core/paragraph',
            'core/heading', 
            'core/image',
            'core/list',
            'core/button',
            'core/quote',
            'core/separator',
            'puroclean/icon-and-title'
        ];

        const TEMPLATE = [
            ['core/paragraph', { placeholder: 'Add your content here...' }]
        ];

        return (
            <>
                <InspectorControls>
                    <PanelBody title={__('Card Settings', 'puroclean')} initialOpen={true}>
                        <SelectControl
                            label={__('Background Color', 'puroclean')}
                            value={backgroundColor}
                            options={[
                                { label: __('Red', 'puroclean'), value: 'red' },
                                { label: __('Blue', 'puroclean'), value: 'blue' }
                            ]}
                            onChange={(value) => setAttributes({ backgroundColor: value })}
                        />
                    </PanelBody>
                </InspectorControls>

                <div {...blockProps}>
                    {/* Editor Preview */}
                    <div className={`p-8 rounded-[10px] text-white ${getBackgroundClass(backgroundColor)}`}>
                        <InnerBlocks
                            allowedBlocks={ALLOWED_BLOCKS}
                            template={TEMPLATE}
                            templateLock={false}
                        />
                    </div>
                </div>
            </>
        );
    },
    save() {
        return <InnerBlocks.Content />;
    }
}); 